// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__8P16X","error":"Button_error__2D9L3","success":"Button_success__2UsRj","primary":"Button_primary__1rE5l"};